module.exports = __webpack_public_path__ + "media/goldDrop.49259c90.mp3";